import Vue from 'vue'
import Vuex from 'vuex'
import promokit from '../utils/promokit';
import { getPath } from '../utils/getStaticPath'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: '',
    country: '',
    locale: '',
    staticPath: '',
    isIntro: true,
    initDataComplete: false,
    initLoadComplete: false,
    contentsData: {},
    documentSize: {
      w: 1920,
      h: 1080,
    },
    breakPoint: 'pc',
    currentPage: "",
    clipQuery: 0,
    isMovePage: false,
    isLayer: false,
    dragPos: {
      isDrag: false,
      isWheel: false,
      c: false,
      s: {
        x: 0,
        y: 0
      },
      d: {
        x: 0,
        y: 0
      }
    },
    firstMain: true,
    enterPage: null,
    selectClip: null,
    adkey: '',
  },
  mutations: {
    setBreakPoint(state, payload) {
      state.breakPoint = payload;
    },
    setLang(state, payload) {
      state.lang = payload;
    },
    setCountry(state, payload) {
      state.country = payload;
    },
    setLocale(state, payload) {
      state.locale = payload;
    },
    setStaticPath(state, payload) {
      state.staticPath = payload;
    },
    setIsIntro(state, payload) {
      state.isIntro = payload;
    },
    setInitDataComplete(state, payload) {
      state.initDataComplete = payload;
    },
    setInitLoadComplete(state, payload) {
      state.initLoadComplete = payload;
    },
    setContentsData(state, payload) {
      state.contentsData = payload;
    },
    setDocumentSize(state, payload) {
      state.documentSize = payload;
    },
    setDragPos(state, payload) {
      state.dragPos = Object.assign({}, state.dragPos, payload);
    },
    setCurrentPage(state, pageName) {
      state.currentPage = pageName;
    },
    setClipQuery(state, payload) {
      state.clipQuery = payload;
    },
    setIsMovePage(state, payload) {
      state.isMovePage = payload;
    },
    setPageMoveType(state, payload) {
      state.pageMoveType = payload;
    },
    setEnterPage(state, payload) {
      state.enterPage = payload;
    },
    setSelectClip(state, payload) {
      state.selectClip = payload;
    },
    setIsLayer(state, payload) {
      state.isLayer = payload;
    },
    setAdkey(state, payload) {
      state.adkey = payload;
    },
  },
  getters: {
    getDragPos(state) {
      return state.dragPos;
    },
    getPreorderURL(state) {
      if(state.locale === 'RU'){
        return 'https://lineagew.plaync.com/ru/board/notice/view?articleId=615c215e8eb22c3ded0d21e6&viewMode=compact&size=18';
      }
      else{
        let params = '';
        if (state.adkey != '') params = `${state.adkey}`
        return '/' + state.country.toLowerCase() + state.contentsData.preorder.link + params;
      }
    }
  },
  actions: {
    initData({ commit, getters }) {
      let contents = null;
      const contiPath = getPath()

      const path = promokit.util.getStaticPath(promokit.util.getNetwork());

      if (promokit.util.getNetwork() == 'file') {
        contents = axios.get(`/data/contentsData-${this.state.lang}.json`);
        axios.all([contents])
          .then(axios.spread((contentsRes) => {
            commit('setContentsData', contentsRes.data);
            commit('setInitDataComplete', true);
          }
          ))
        commit('setStaticPath', path + '');

      } else {

        // contents = axios({
        //   method: 'GET',
        //   responseType: 'json',
        //   url: `https://${contiPath}lineagew.plaync.com/conti/getContent?service=lineagew&alias=brand-sc-media&lang=ko-KR`,
        //   headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        //   data: {},
        // })
        //
        // axios.all([contents])
        //   .then(axios.spread((contentsRes)=>{
        //     console.log(contentsRes.data)
        //       commit('setContentsData', contentsRes.data);
        //       commit('setInitDataComplete', true);
        //     }
        //   ))
        window.loadedYoutubeApi = true;
        commit('setStaticPath', path + '/promo/lineagew/teasing/2nd');
        commit('setContentsData', window.contentsJson);
        commit('setInitDataComplete', true);
      }
    }
  },
  modules: {
  }
})

